var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',{attrs:{"vid":_vm.vid,"rules":_vm.rules,"name":_vm.label},scopedSlots:_vm._u([{key:"default",fn:function({ errors, invalid, dirty, validated }){return [_c('el-form-item',{class:[
      'form-item',
      _vm.formItemClass,
      { 'is-error': invalid && (dirty || validated) },
      `margin-bottom-size--${_vm.marginBottomSize}`,
    ],attrs:{"size":_vm.size}},[(_vm.label)?_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_vm._t("default"),(invalid && (dirty || validated))?_c('small',{staticClass:"el-form-item__error"},[_vm._v(_vm._s(errors[0]))]):_vm._e()],2)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }